import { useEffect, useState } from "react";

const View = ({show, children, customClass='test'}) => {
    const [showClass, setShowClass] = useState('');
    const [activeClass, setActiveClass] = useState('');
    const moduleName = 'view';
    const modifierClass = customClass ? `${moduleName}--${customClass}` : '';

    useEffect(() => {
        if ( show ) {
            setActiveClass('active');
        } else {
            setActiveClass('');
        }
    }, [show])

    return (
        <div className={`view ${showClass}  ${activeClass} ${modifierClass}`}>
            { children }
        </div>
    )
}

export default View;